import React from "react";
import HederaImage from "../../images/hedera-logo.png";

const HederaLogo = () => {
  return <img src={HederaImage} alt="SEQWater logo" />;
};

export default HederaLogo;
